import { defineStore } from 'pinia'

import type { SurveysStore } from './interfaces'

import { emptySurveysFilters } from '@helpers/surveys-query'

import { actions } from './actions'
import { getters } from './getters'

export const useSurveysStore = defineStore('surveys', {
  state: (): SurveysStore => ({
    loading: false,
    exporting: false,
    disciplineId: null,
    surveys: [],
    meta: null,
    filters: emptySurveysFilters(),
    currentPage: 1,
    perPage: 25,
  }),
  actions,
  getters,
})
